import type { SVGProps } from "react";
export interface EuroCircleIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function EuroCircleIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: EuroCircleIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 12a8.875 8.875 0 1 0-17.75 0 8.875 8.875 0 0 0 17.75 0m2.25 0c0 6.144-4.98 11.124-11.124 11.125S.875 18.145.875 12 5.856.875 12.001.875c6.143 0 11.124 4.981 11.124 11.126Z"
      />
      <path
        fill={color}
        d="M5.875 12q.001-.192.014-.381A1.125 1.125 0 0 1 6 9.375h.466A6.125 6.125 0 0 1 16.9 8.325a1.125 1.125 0 0 1-1.8 1.35 3.87 3.87 0 0 0-5.946-.301H11.5l.114.005a1.126 1.126 0 0 1 0 2.239l-.114.005H8.143a4 4 0 0 0 0 .75H11.5l.115.006a1.126 1.126 0 0 1 0 2.239l-.114.005H9.155a3.868 3.868 0 0 0 5.946-.3l.073-.088a1.125 1.125 0 0 1 1.726 1.44l-.217.271a6.126 6.126 0 0 1-10.219-1.323H6a1.125 1.125 0 0 1-.111-2.245 6 6 0 0 1-.014-.38Z"
      />
    </svg>
  );
}
